<template>
    <card title="Retail Location Hours" :no-padding="true">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>Days</th>
                    <th>Open Time</th>
                    <th>Close Time</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(workingHour, index) in workingHours" :key="index">
                    <td>
                        {{ formatDays(workingHour.days) }}
                    </td>
                    <td>
                        {{ formatTime(workingHour.open_time) }}
                    </td>
                    <td>
                        {{ formatTime(workingHour.close_time) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </card>
</template>

<script>
import dayjs from '~/utils/dayjs';
import Card from '../../../general/Card.vue';

export default {
    components: {
        Card,
    },
    props: {
        workingHours: {
            required: true,
            type: Array
        }
    },
    methods: {
        formatDays(days) {
            return days.join(days.length > 2 ? ', ' : ' - ')
        },
        formatTime(time) {
            time = time.split(':')
            return dayjs().hour(time[0]).minute(time[1]).format('hh:mm A')
        }
    }
};
</script>
